export const Congiguration = {
    CompanyId: 1,
    CRMApi: 'https://cpqappcrmserv-api-qa.workplaceoptions.com',
    CPQApi: 'https://cpqappserv-api-qa.workplaceoptions.com',
    CPQEmailUrlBaseAddress: 'https://cpqappserv-ui-qa-linux2.workplaceoptions.com',

    CRMApiClientName: 'CPQ',
    CRMApiPassword: 'C0570m36#u693n5@5',
    ClientName: 'CPQ',
    Passcode: 'C0570m36#u693n5@5',
    Build: "1010",
    Version: "1.1.0",
    Year: 2024,
    pageNotFoundTextStart: "This page doesn't exist. Please launch the Pricing tool from ",
    crmAppName: "Dynamic CRM",
    crmLink: "https://workplaceoptions0.crm.dynamics.com/",
    unauthorizedStatus: 404,
    pageNotFound404: "You are not authorized to view this page.",
    CPQAPIMKey: '0c2b163ef611423e95830caf77e5538b',//QA    
    //Added for redeployment
    CRMAPIMKey: '06115fe860d94f29aafd60c15de8cec3',//QA--CPQDev
    //CRMAPIMKey: 'b5ec7a22d89a4c5393b9ea6fdcd1edb6',//Dev(Sandbox)--CPQQA
    //CRMAPIMKey: '636b028190a54f29874978c285b1e374',//Security
    //CRMAPIMKey: '653e94fc28b64497a955a041f11487f2',//Prod


    pageNotFoundTextStart: "This page doesn't exist. Please launch the Pricing tool from ",
    crmAppName: "Dynamic CRM",
    crmLink: "https://workplaceoptions0.crm.dynamics.com/",
    Build: "1010",
    Version: "4.0.0",
    Year: 2026,
    unauthorizedStatus: 404,
    pageNotFound404: "You are not authorized to view this page."
}